module.exports = __webpack_public_path__ + "img/wb-square.aa255432.png";